export class DialogData {
    title: string;
    content: string;
    buttonActionYes: string;
    buttonActionNo: string;
    buttonClick: any;
    metadata: any;
}
